import React from 'react'
import styled from 'styled-components'

const TagButtonStyled = styled.button<{ active?: boolean }>`
  border: none;
  cursor: pointer;
  height: 30px;
  font-size: 12px;
  font-weight: 400;
  padding: 6px 8px;
  background: ${({ theme, active }) => (active ? theme.primary1 : 'transparent')};
  transition: all 200ms;
  border: 0.5px solid ${({ theme, active }) => (active ? theme.primary1 : theme.bg3)};
  color: ${({ theme, active }) => (active ? theme.text5 : 'rgb(195, 197, 203)')};

  &:hover {
    border: 0.5px solid ${({ theme }) => theme.primary1};
    color: ${({ theme, active }) => (active ? theme.text5 : theme.primary1)};
  }

  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  display: flex;
  align-items: center;

  svg {
    margin-right: 4px;
  }
`

interface TagButtonI {
  onClick: () => void
  children: string | JSX.Element | JSX.Element[] | Element | Element[] | any
  active?: boolean
  style?: React.CSSProperties
}

const TagButton: React.FC<TagButtonI> = ({ onClick, children, active = false, style }) => {
  return (
    <TagButtonStyled onClick={() => onClick()} active={active} style={style}>
      {children}
    </TagButtonStyled>
  )
}
export default TagButton
